import { atom, useRecoilState, useResetRecoilState } from 'recoil'

import { localStorageEffect } from '@/capacitor/recoil/localstorage-effect'

const remecareWarning = atom<boolean>({
  key: '@app/remecareWarning',
  default: false,
  effects: [localStorageEffect('@app/remecareWarning')],
})

export function useRemecareWarning() {
  const [remecareWarningState, setRemecareWarningState] = useRecoilState(remecareWarning)
  const resetRemecareWarningState = useResetRecoilState(remecareWarning)

  return {
    resetRemecareWarningState,
    setRemecareWarningState,
    remecareWarningState,
  }
}
